import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';
import DImage from '../../pieces/DImage';
import workflowImage from './WorkflowImage_1.jpg';

export default function WhatIsAWorkflow() {

    return (
        <div>
            <DHeader>What is a Workflow?</DHeader>
       
            <DText>
            A workflow is a sequence of Actions (functions) that are executed in a predefined order to perform a task. Each Action takes in multiple inputs and generates outputs. The inputs to each step/function could be user-specified but at least one of its inputs is based on the ouput of a previous Action/Node.
            
            </DText>
            <DText>
            Let us look at an example of a workflow. The diagram below shows the workflow in graphical form. This example involves text manipulation. It takes in a text input and transforms it by adding string subtext to it.
            </DText>

            <DText>
            The task is broken down into its components, each of which is performed by a specific player. Each player could be an API call, a computation, a database read or write etc. 
            </DText>

            <DHeader>Example Workflow</DHeader>

            <DImage src={workflowImage} alt="Example Workflow" />

            <DText>
            The workflow has two functions. Each function takes in the string input and transforms it into a different output. 
           
            </DText>

            <DText>
            The first function model0 takes in a string and adds “_model0” to the string. This then becomes the input to the next node in the workflow.
            </DText>

            <DCode>
              {`def model0(input0:str)->(str):
    print("Model 0 :", input0)
    output = input0+"_model0"
    return output
              `}
            </DCode>

            <DText>
            The second function model1 adds “_model1” to the input string
            </DText>

            <DCode>
              {`def model1(input1:str)->(str):
    print("Model 1 :", input1)
    output = input1 + "_model1"
    return output`}
            </DCode>
            
       
        </div>
    )
}